import React from 'react'

const Footer = () => (
  <footer>
      <div className="footer-logo">
        <img src="/assets/4zzz.svg" />
      </div>
      <div style={{ margin: '20px' }}>
       <div id="contact-block">

        <div className="footer-contact">
          <strong>4ZZZ RADIO BRISBANE</strong><br />
          <strong>102.1 FM & ZED DIGITAL</strong><br />
          <strong>Phone</strong> +61 7 3252 1555<br />
          <strong>SMS</strong> 0420 626 733<br />
          <strong>Email</strong> reception@4zzz.org.au
          <div className="footer-socials">
            <a href="https://facebook.com/4zzzradio" target="_blank">
              <span className="fa-stack">
                <i className="fa fa-circle fa-stack-2x"></i>
                <i className="fa fa-facebook fa-stack-1x fa-inverse"></i>
                </span>
            </a>
            <a href="https://instagram.com/4zzzradio" target="_blank">
              <span className="fa-stack">
                <i className="fa fa-circle fa-stack-2x"></i>
                <i className="fa fa-instagram fa-stack-1x fa-inverse"></i>
              </span>
            </a>
            <a href="https://twitter.com/4zzzradio" target="_blank">
              <span className="fa-stack">
                <i className="fa fa-circle fa-stack-2x"></i>
                <i className="fa fa-twitter fa-stack-1x fa-inverse"></i>
              </span>
            </a>
            <a href="https://youtube.com/4zzz" target="_blank">
              <span className="fa-stack">
                <i className="fa fa-circle fa-stack-2x"></i>
                <i className="fa fa-youtube fa-stack-1x fa-inverse"></i>
              </span>
            </a>
          </div>
       </div>
        <div className="footer-street-address">
          <strong>Street Address</strong><br />
          264 Barry Parade<br />
          Fortitude Valley QLD 4006<br />
          Australia
        </div>
        <div className="footer-opening-hours">
          <strong>Office Hours</strong><br />
          Tuesday to Friday: 10 am to 4pm<br />
          Saturday: 10 am to 2 pm<br />
          Sunday and Monday: Closed
        </div>
        <div className="footer-postal-address">
          <strong>Postal Address</strong><br />
          PO BOX 509<br />
          Fortitude Valley QLD 4006<br/>
          Australia
        </div>
      </div>

      <div id="acknowledgement">
        <div><img src="/assets/fnaa.png" /></div>
        <div className="text">4ZZZ acknowledges the Traditional Owners of the land where we create and broadcast from, the Turrbal, Yuggera and Jagera people, and pay our respect to elders past, present and future. We extend that respect to other Aboriginal and Torres Strait Island People. Sovereignty was never ceded.</div>
         <div><img src="/assets/fnts.png" /></div>
      </div>
    </div>

  </footer>
)

export default Footer
